import request from "@/utils/request";

// 查询地区代理商配置列表
export function getAgentConfigList(params) {
  return request({
    url: "/regionAgentConfig/getRegionAgentList",
    method: "get",
    params
  });
}

// 新增地区代理商配置
export function addAgentConfig(params) {
  return request({
    url: "/regionAgentConfig/add",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 修改地区代理商配置
export function updateAgentConfig(params) {
  return request({
    url: "/regionAgentConfig/update",
    method: "post",
    data: params,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

// 删除地区代理商配置
export function deleteAgentConfig(params) {
  return request({
    url: "/regionAgentConfig/delete",
    method: "get",
    params
  });
}
